import { Routes, Route, useNavigate } from "react-router-dom";
import Home from "./components/Home/Home";
import Login from "./components/Login/Login";
// import Referral from "./components/Referral/Referral";
import Register from "./components/Register/Register";
import AuthLayout from "./container/AuthLayout";
import MainLayout from "./container/MainLayout";
import React, { useState, useEffect } from "react";
import jwtDecode from "jwt-decode";
import { ThemeProvider } from "styled-components";
import WebFont from "webfontloader";
import { GlobalStyles } from "./theme/GlobalStyles";
import { useTheme } from "./theme/useTheme";
import Investment from "./components/Investment/Investment";
import Earn from "./components/Earn/Earn";
import Exchange from "./components/Exchange/Exchange";
import Profile from "./components/Profile/Profile";
import Invite from "./components/Invite/Invite";
import Downlines from "./components/Downlines/Downlines";
// import MainLayoutNoFooter from "./container/MainLayoutNoFooter";
import Balance from "./components/Balance/Balance";
import Deposit from "./components/Deposit/Deposit";
import Withdrawal from "./components/Withdrawal/Withdrawal";
import History from "./components/History/History";
import WithdrawalHistory from "./components/WithdrawalHistory/WithdrawalHistory";
import SetWithdrawalPin from "./components/SetWithdrawalPin/SetWithdrawalPin";
import Withdraw from "./components/Withdraw/Withdraw";
import Guide from "./components/Guide/Guide";
import BuyMiner from "./components/BuyMiner/BuyMiner";
import MinersOwned from "./components/MinersOwned/MinersOwned";
import AccountSettings from "./components/AccountSettings/AccountSettings";
import ContacSupport from "./components/ContacSupport/ContacSupport";
import About from "./components/About/About";
import Reward from "./components/Reward/Reward";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ChangePassword from "./components/ChangePassword/ChangePassword";
import Notifications from "./components/Notifications/Notifications";
import SellMiner from "./components/SellMiner/SellMiner";
import Notification from "./components/Notification/Notification";
import Staking from "./components/Staking/Staking";
import HowToBuyTrx from "./components/HowToBuyTrx/HowToBuyTrx";
import { useDispatch } from "react-redux";
import { logoutUser } from "./feature/auth/AuthActions";
import ReferralContestTC from "./components/ReferralContest/ReferralContestTC";
import ReferralContest from "./components/ReferralContest/ReferralContest";
import Stake from "./components/Stake/Stake";
import Stakes from "./components/Stakes/Stakes";
import WithdrawStake from "./components/Stakes/WithdrawStake";
import ActivateMiner from "./components/ActivateMiner/ActivateMiner";

const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get the selected theme, font list, etc.
  const { theme, themeLoaded, getFonts } = useTheme();
  const [selectedTheme, setSelectedTheme] = useState(theme);

  useEffect(() => {
    setSelectedTheme(theme);
  }, [theme, themeLoaded]);

  // Load all the fonts
  useEffect(() => {
    WebFont.load({
      google: {
        families: getFonts(),
      },
    });
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      if (decodedToken.exp * 1000 < Date.now()) {
        dispatch(logoutUser({}));
        window.location.pathname = "/login";
      }
    }
  }, [dispatch, navigate]);

  return (
    <>
      {themeLoaded && (
        <ThemeProvider theme={selectedTheme}>
          <GlobalStyles />
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/investment" element={<Investment />} />
              <Route path="/earn" element={<Earn />} />
              <Route path="/exchange" element={<Exchange />} />
              <Route path="/profile" element={<Profile />} />
              {/* </Route>
            <Route path="/" element={<MainLayoutNoFooter />}> */}
              <Route path="/about" element={<About />} />
              <Route path="/account-settings" element={<AccountSettings />} />
              <Route path="/balance" element={<Balance />} />
              <Route path="/buy-miner" element={<BuyMiner />} />
              <Route path="/re-activate-miner" element={<ActivateMiner />} />
              <Route path="/sell-miner" element={<SellMiner />} />
              <Route path="/contact-support" element={<ContacSupport />} />
              <Route path="/deposit/:id" element={<Deposit />} />
              <Route path="/downlines" element={<Downlines />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/history" element={<History />} />
              <Route path="/how-to-get-trx" element={<HowToBuyTrx />} />
              <Route path="/invite" element={<Invite />} />
              <Route path="/miners-owned" element={<MinersOwned />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/notification/:id" element={<Notification />} />
              <Route path="/staking" element={<Staking />} />
              <Route path="/stake" element={<Stake />} />
              <Route path="/stakes" element={<Stakes />} />
              <Route path="/withdraw-stake" element={<WithdrawStake />} />
              <Route path="/reward" element={<Reward />} />
              <Route
                path="/pubmining-referral-contest-tc"
                element={<ReferralContestTC />}
              />
              <Route path="/referral-contest" element={<ReferralContest />} />
              <Route
                path="/set-withdrawal-pin"
                element={<SetWithdrawalPin />}
              />
              <Route path="/withdrawal" element={<Withdrawal />} />
              <Route path="/withdraw" element={<Withdraw />} />
              <Route
                path="/withdrawal-history"
                element={<WithdrawalHistory />}
              />
              <Route path="/change-password" element={<ChangePassword />} />
            </Route>
            <Route path="/" element={<AuthLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
            </Route>
          </Routes>
        </ThemeProvider>
      )}
    </>
  );
};

export default App;
